if (!customElements.get('dbc-accordion-image')) {
  customElements.define('dbc-accordion-image', class extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-feature-id]'));
      this.images = Array.from(this.querySelectorAll('[data-image-id]'));
      this.onClick = (event) => {
        const trigger = event.target.closest('.dbc-details__trigger');
        if (trigger) this.selectItem(trigger.closest('[data-feature-id]'));
      };
      this.onBlockSelect = (event) => {
        const item = this.items.find((entry) => entry.dataset.featureId === event.detail.blockId);
        if (item) this.selectItem(item);
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('shopify:block:select', this.onBlockSelect);
      if (this.items.length) this.selectItem(this.items.find((item) => item.classList.contains('is-active')) || this.items[0]);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    selectItem(selected) {
      if (!this.items.includes(selected)) return;
      this.items.forEach((item) => {
        const active = item === selected;
        item.classList.toggle('is-active', active);
        const trigger = item.querySelector('.dbc-details__trigger');
        trigger.setAttribute('aria-expanded', String(active));
        trigger.setAttribute('aria-disabled', String(active));
        item.querySelector('.dbc-details__description').hidden = !active;
      });
      this.images.forEach((panel) => {
        const active = panel.dataset.imageId === selected.dataset.featureId;
        panel.hidden = !active;
        // Start loading immediately when an editor selection or click reveals an image.
        const image = panel.querySelector('img');
        if (active && image) image.loading = 'eager';
      });
    }
  });
}
